// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1VJhs","notes":"Notes_notes__2Fib5"};